
// software mockup on PDP - gif, image or video
function changeSoftwareMockup(){
  // mobile
  if ($(window).width() < 769) {
    var mobileSoftware = $('#software-image').attr('data-software-mobile');
    var defaultMobileSoftware = $('#software-image').attr('src');
    if (defaultMobileSoftware != mobileSoftware) {
      $('#software-image').attr('src', mobileSoftware);
    }
  // tablet
  } else if($(window).width() < 1025) {
    var tabletSoftware = $('#software-image').attr('data-software-tablet');
    var defaulTabletSoftware = $('#software-image').attr('src');
    if (tabletSoftware != defaulTabletSoftware) {
      $('#software-image').attr('src', tabletSoftware);
    }
  // desktop
  } else {
    var desktopSoftware = $('#software-image').attr('data-software-desktop');
    var defaultDesktopSoftware = $('#software-image').attr('src');
    if (desktopSoftware != defaultDesktopSoftware) {
      $('#software-image').attr('src', desktopSoftware);
    }
  }
}
changeSoftwareMockup();


// mobile draggable version
function changeDraggable(){
  if ($(window).width() < 769) {
    var mobileDraggable = $('.mask img').attr('data-draggable-mobile');
    var mobileMask = $('.mask_overlay').attr('data-draggable-mask-mobile');
    $('.mask img').attr('src', mobileDraggable);
    $('.mask_overlay').css('background-image', 'url(' + mobileMask + ')');
  } else {
    var desktopDraggable = $('.mask img').attr('data-draggable-desktop');
    var desktopMask = $('.mask_overlay').attr('data-draggable-mask-desktop');
    $('.mask img').attr('src', desktopDraggable);
    $('.mask_overlay').css('background-image', 'url(' + desktopMask + ')');
  }
}
changeDraggable();

// on page resize
$(window).on('resize', function(){
  changeSoftwareMockup();
  changeDraggable();
});

// on click what you get images
$(document).on('click','.col-images .inner .stacked-image',function(){
  $('.inner .stacked-image').css('z-index', '0');
  $('.inner .stacked-image').css('box-shadow', 'unset');
  $(this).css('z-index', '1');
  $(this).css('box-shadow', '0 80px 60px 0 rgb(0 0 0 / 20%)');
});


/*
Custom variant picker PDP
*/
// var productPrice = $('#ProductPrice').attr('content');
// $('.product-dropdown  .item').on('click', function() {
//   var variantValue = $(this).attr('data-variant-value');
//   // console.log(variantValue);
//   $('#Quantity').val(variantValue);
//   $('#ProductPrice').html('$' + variantValue * productPrice);
// });

/*
handle arrow PDP
*/
$('.handle-arrow').on('mousedown', function() {
  $(this).addClass('active');
});

if ( $('.template-product').length > 0 && $('.template-shape-box').length == 0) {
  
  // load PDP page on top
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  } else {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
  }
}

setTimeout(function(){ 
  if ( $('.template-product').length > 0 && $('.product-single__meta--wrapper').length > 0 ) {
    var stickyPdpElementHeight = $('.product-single__meta--wrapper').height();
    var stickyPdpElementPosition = $('.product-single__meta--wrapper').offset().top;
    var leftOffset = $('.sticky-product-tabs').offset().left - 40;


    console.log($('.product__tabs').offset().top);

    // when announcement bar is hidden
    if (document.cookie.indexOf('Announcementbar') !== -1 ) {
      var productTabsPosition = $('.product__tabs').offset().top - stickyPdpElementHeight;
      var stickyPdpElementPosition = stickyPdpElementPosition - 66;
    } else {
      var stickyPdpElementPosition = stickyPdpElementPosition - 28;
      var productTabsPosition = $('.product__tabs').offset().top - stickyPdpElementHeight;
    }

    console.log('stickyPdpElement', stickyPdpElementPosition);
    console.log('productTabsPosition', productTabsPosition);
    console.log('leftoffset', leftOffset);
    
    $(window).on('scroll', function() {
      // console.log('test');
      if ($(window).width() > 1024) {
        var windowTop = $(window).scrollTop();
        console.log("windowtop",windowTop + stickyPdpElementPosition);
        console.log(productTabsPosition);
    
        
        if (windowTop > stickyPdpElementPosition) {
          $('.product-single__meta--wrapper').addClass('sticky');
          $('.product-single__meta--wrapper').css('top', 0 );
          $('.product-single__meta--wrapper').css('right', leftOffset);
          
          
          // if stickyPDP element is at the product tab section
          if (windowTop > productTabsPosition) {
            // console.log(windowTop);
    
            var total = windowTop - productTabsPosition - stickyPdpElementHeight;
            var totalMin = total + stickyPdpElementHeight;
    
            // show the add to cart trigger in the product tabs
            if (total > 0) {
              $('.add-to-cart-trigger').addClass('active');
            } else {
              $('.add-to-cart-trigger').removeClass('active');
            }
    
            // when zero, the pdp element should be outside the page
            $('.product-single__meta--wrapper').css('top', -totalMin );
          }
    
        } else if (windowTop < stickyPdpElementPosition ) {
          $('.product-single__meta--wrapper').removeClass('sticky');
          $('.product-single__meta--wrapper').css('top', 'auto' );
          $('.product-single__meta--wrapper').css('right', '40px');
        }
    
      }
    
    });
    
  }

 }, 1000);



// font testing
if ( $('#fontSize').length > 0 ) {
  var fontSize = $('#fontSize').val();
  // console.log(fontSize);
  
  var fontSizeSlider = document.getElementById("fontSize");
  var fontSizeOutput = document.getElementById("fontSizeValue");
  fontSizeOutput.innerHTML = fontSizeSlider.value;
  
  fontSizeSlider.oninput = function() {
    fontSizeOutput.innerHTML = this.value;
    $('.font-output').css('font-size', fontSizeOutput.innerHTML + 'px');
  }
  
  var lineHeightSlider = document.getElementById("lineHeight");
  var lineHeightOutput = document.getElementById("lineHeightValue");
  lineHeightOutput.innerHTML = lineHeightSlider.value;
  
  lineHeightSlider.oninput = function() {
    lineHeightOutput.innerHTML = this.value;
    $('.font-output').css('line-height', lineHeightOutput.innerHTML + 'px');
  }
  
  var letterSpacingSlider = document.getElementById("letterSpacing");
  var letterSpacingOutput = document.getElementById("letterSpacingValue");
  letterSpacingOutput.innerHTML = letterSpacingSlider.value;
  
  letterSpacingSlider.oninput = function() {
    letterSpacingOutput.innerHTML = this.value;
    $('.font-output').css('letter-spacing', letterSpacingOutput.innerHTML + 'px');
  }
  
  $('#fontName').change(function() {
    var fontName = $(this).val();
    $('.font-output').css('font-family', fontName);
  });

  $('#font-input').on('input', function(){
    var inputValue = $(this).val();
    $('.font-output').text(inputValue);
  });
  
}


var swiper = new Swiper(".shapeBoxSwiper", {
  spaceBetween: 20,
  slidesOffsetBefore: 30,
  slidesOffsetAfter: 330,
  slideToClickedSlide: false,
  slidesPerView: "auto",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
    draggable: true,
    dragSize: 10,
  },
  breakpoints: {
    380: {
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 340
    },
    425: {
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 370
    },
    470: {
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 420
    },
    520: {
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 490
    },
    768: {
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 900
    },
    1024: {
      threshold: 10,
      slidesOffsetAfter: 900,
      slidesOffsetBefore: 500
    },
    1375: {
      threshold: 40,
      slidesOffsetBefore: 600,
      slidesOffsetAfter: 1100
    },
    1550: {
      threshold: 40,
      slidesOffsetBefore: 600,
      slidesOffsetAfter: 1300
    },
    1800: {
      threshold: 40,
      slidesOffsetBefore: 800,
      slidesOffsetAfter: 1400
    },
    1950: {
      threshold: 40,
      slidesOffsetBefore: 1000,
      slidesOffsetAfter: 1400
    },
    2200: {
      threshold: 40,
      slidesOffsetBefore: 1200,
      slidesOffsetAfter: 1600
    },
    2400: {
      threshold: 40,
      slidesOffsetBefore: 1200,
      slidesOffsetAfter: 1800
    }
  }
});

swiper.on('setTranslate', function () {
  if (window.innerWidth >= 768 ) {
    setTimeout(function() {
      if ($('.swiper-slide.swiper-slide-1').offset().left < 0 ) {
        $('.first-content').addClass('hide');
      } else {
        $('.first-content').removeClass('hide');
      }
    }, 100);
    setTimeout(function() {
      var slideOffset = $(window).width() - ($('.swiper-slide.swiper-slide-last').offset().left + $('.swiper-slide.swiper-slide-last').outerWidth());
      var lastContentOffset = $(window).width() - ($('.last-content .inner').offset().left + $('.last-content .inner').outerWidth());
      
      if (slideOffset > lastContentOffset) {
        $('.last-content').removeClass('hide');
      } else {
        $('.last-content').addClass('hide');
      }
    }, 200);
  } else {
    setTimeout(function() {
      var slideOffset = $(window).width() - ($('.swiper-slide.swiper-slide-last').offset().left + $('.swiper-slide.swiper-slide-last').outerWidth());
      var lastContentOffset = $(window).width() - ($('.last-content .inner').offset().left + $('.last-content .inner').outerWidth());
      
      if (slideOffset > lastContentOffset) {
        $('.last-content').removeClass('hide');
      } else {
        $('.last-content').addClass('hide');
      }
    }, 200);
    // var slideCount = $('.product__categories-slider .swiper-slide').length - 1;
    // if (slideCount == swiper.activeIndex) {
    //   $('.last-content').removeClass('hide');
    // } else {
    //   $('.last-content').addClass('hide');
    // }
  }
});


function magnify(imgID, zoom) {
  var img, glass, w, h, bw;
  img = document.getElementById(imgID);
  /*create magnifier glass:*/
  glass = document.createElement("DIV");
  glass.setAttribute("class", "img-magnifier-glass");
  /*insert magnifier glass:*/
  img.parentElement.insertBefore(glass, img);
  /*set background properties for the magnifier glass:*/
  glass.style.visibility = "hidden";
  glass.style.backgroundImage = "url('" + img.src + "')";
  glass.style.backgroundRepeat = "no-repeat";
  glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
  bw = 3;
  w = glass.offsetWidth / 2;
  h = glass.offsetHeight / 2;
  glass.addEventListener("load", moveMagnifier);
  setTimeout(function() {
    glass.addEventListener("load", moveMagnifier);
  }, 300);
  /*execute a function when someone moves the magnifier glass over the image:*/
  glass.addEventListener("mousemove", moveMagnifier);
  img.addEventListener("mousemove", moveMagnifier);
  /*and also for touch screens:*/
  glass.addEventListener("touchmove", moveMagnifier);
  img.addEventListener("touchmove", moveMagnifier);
  function moveMagnifier(e) {
    var pos, x, y;
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();
    /*get the cursor's x and y positions:*/
    pos = getCursorPos(e);
    console.log(pos);
    if (pos.y < 0) {
      $('.img-magnifier-glass').hide();
    } else {
      $('.img-magnifier-glass').show();
    }
    x = pos.x;
    y = pos.y;
    glass.style.visibility = "visible";
    /*prevent the magnifier glass from being positioned outside the image:*/
    if (x > img.width - (w / zoom)) {x = img.width - (w / zoom);}
    if (x < w / zoom) {x = w / zoom;}
    if (y > img.height - (h / zoom)) {y = img.height - (h / zoom);}
    if (y < h / zoom) {y = h / zoom;}
    /*set the position of the magnifier glass:*/
    glass.style.left = (x - w) + "px";
    glass.style.top = (y - h) + "px";
    /*display what the magnifier glass "sees":*/
    glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
  }
  function getCursorPos(e) {
    var a, x = 0, y = 0;
    e = e || window.event;
    /*get the x and y positions of the image:*/
    a = img.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x : x, y : y};
  }
}

if ( $('#icon-mask-image').length > 0 ) {
  // Make sure it always starts @ zero position for below calcs to work
  $("#icon-mask-image").css({top: 0, left: 0});
  
  var maskWidth  = $("#icon-mask").width();
  var maskHeight = $("#icon-mask").height();
  var imgPos     = $("#icon-mask-image").offset();
  var imgWidth   = $("#icon-mask-image").width();
  var imgHeight  = $("#icon-mask-image").height();
  
  var x1 = (imgPos.left + maskWidth) - imgWidth;
  var y1 = (imgPos.top + maskHeight) - imgHeight;
  var x2 = imgPos.left;
  var y2 = imgPos.top;
  
  $("#icon-mask-image").draggable({ containment: [x1,y1,x2,y2] });
  $("#icon-mask-image").css({cursor: 'move'});
}


$(document).ready(function() { 
  $('.product__categories-slider .swiper-slide').on('click', function () {
    var popupImage = $('.swiper-slide-active').html();
    $('.swiper-popup-inner').append(popupImage);
    $('.swiper-popup').addClass('show');
    $('body').addClass('swiper-popup-enabled');
    if (window.innerWidth >= 1024) {
      magnify("swiperPopupImage", 3);
    } else {
      // Make sure it always starts @ zero position for below calcs to work
      $("#icon-mask-image").css({top: 0, left: 0});

      var maskWidth  = $("#icon-mask").width();
      var maskHeight = $("#icon-mask").height();
      var imgPos     = $("#icon-mask-image").offset();
      var imgWidth   = $("#icon-mask-image").width();
      var imgHeight  = $("#icon-mask-image").height();

      var x1 = (imgPos.left + maskWidth) - imgWidth;
      var y1 = (imgPos.top  + maskHeight) - imgHeight;
      var x2 = imgPos.left;
      var y2 = imgPos.top;

      $("#icon-mask-image").draggable({ containment: [x1,y1,x2,y2] });
      $("#icon-mask-image").css({cursor: 'move'});

      
      // $("#icon-mask-image").draggable({ containment: [x1,y1,x2,y2] });
      // $('#icon-mask-image').draggable({ start: function() {
      //   var imgPos     = $("#icon-mask-image").offset();

      //   console.log(imgPos);

      //   // $(this).css({transform: "none", top: $(this).offset().top+"px", left:$(this).offset().left+"px"});
        
      //   } });
      // $("#icon-mask-image").css({cursor: 'move'});
    }
    $('.swiper-popup-inner .icon-close').on('click', function(){
      $('.swiper-popup').removeClass('show');
      $('body').removeClass('swiper-popup-enabled');
      $('.swiper-popup-inner').empty();
    });
    $(document).on('keyup', function(e) {
      if (e.key == "Escape") {
        $('.swiper-popup').removeClass('show');
        $('body').removeClass('swiper-popup-enabled');
        $('.swiper-popup-inner').empty();
      }
    });
  });
});

swiper.on('reachEnd', function () {
  if (window.innerWidth >= 768 ) {
    $('.last-content').removeClass('hide');
  }
}); 

$(document).click(function(e) { 
  clicked_class = $(e.target).attr('class');
  if (clicked_class == 'swiper-popup show') {
    $('.swiper-popup').removeClass('show');
    $('body').removeClass('swiper-popup-enabled');
    $('.swiper-popup-inner').empty();
  }
});

swiper.on('click', function () {
  if (window.innerWidth >= 768 ) {
    setTimeout(function() {
      var slideOffset = $(window).width() - ($('.swiper-slide.swiper-slide-last').offset().left + $('.swiper-slide.swiper-slide-last').outerWidth());
      var lastContentOffset = $(window).width() - ($('.last-content .inner').offset().left + $('.last-content .inner').outerWidth());
      if (slideOffset > lastContentOffset) {
        $('.last-content').removeClass('hide');
      } else {
        $('.last-content').addClass('hide');
      }
    }, 200);
  }
});


if ( $('.template-product').length > 0 ) {
    $(".mask img").load(function(){
      var baseImageHeight = $('.mask img').height();
      // console.log('heightttttt', baseImageHeight);
      $('.mask_overlay').css('height', baseImageHeight);
    });
  
  $( window ).resize(function() {
    var baseImageHeight = $('.mask img').height();
    $('.mask_overlay').css('height', baseImageHeight);
  });
  
  // $('.mask_overlay').css('width',$('.mask_handle').css('left'));
  $( ".mask_handle" ).click(function(e){
    e.preventDefault();
  });
  $('.mask_handle').draggable({
    addClasses: true,
    cancel: false,
    classes: {
      "ui-draggable": "highlight"
    },
    containment: "parent",
    axis: "x",
    drag: function( event, ui ) {
        x_position = $(this).css('left');
        new_x_position = x_position.replace('px', '');
        x_position = parseInt(new_x_position)+7;
        $('.mask_overlay').css('width',x_position );
    },
    stop: function( event, ui ) {
      x_position = $(this).css('left');
      new_x_position = x_position.replace('px', '');
      x_position = parseInt(new_x_position)+7;
      $('.mask_overlay').css('width',x_position );
    }
  });
}

// pdp testimonials section
const swiper2 = new Swiper('.swiper-container-testimonials', {
  slidesPerView: 1.1,
  spaceBetween: 10,
  loop: true,
  centeredSlides: true,
  simulateTouch: true,
  slideToClickedSlide: true,
  grabCursor: true,
  autoHeight: true,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 25
    }
  }
});

// pdp testimonials section
const swiper3 = new Swiper('.swiper-shape-testimonials', {
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: false,
  simulateTouch: true,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  slideToClickedSlide: true,
  grabCursor: true,
  autoHeight: true,
  breakpoints: {
    768: {
      slidesPerView: 1.6,
      spaceBetween: 0
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 0,
      slidesOffsetBefore: 80,
      slidesOffsetAfter: 200
    }
  }
});